var lib_core = require("lib-core");
if(typeof window !== 'undefined')
    var ui_extensions = require("ui-extensions");

var SymbolGeneratorTerminalInteractionModel = function (list, idx) {
    this.makeObservableTreeNode();

    this.list = list;
    this.idx = idx;

    // shadows for inspector
    this.showName = this.shadow("showName",
        function () {
            return this.list.get(this.idx);
        },
        function (value) {
            return this.list.put(this.idx, value);
        },
        [[this.list, this.list.onPut]]
    );
};
lib_core.mixin(SymbolGeneratorTerminalInteractionModel, lib_core.ObservableTreeNode);
lib_core.JsonParser.registerClass(SymbolGeneratorTerminalInteractionModel, "SymbolGeneratorTerminalInteractionModel");

SymbolGeneratorTerminalInteractionModel.prototype.getInspectorElements = function () {
    var inspectorElements = {};

    inspectorElements.input_elements = [{
        label      : 'Name',
        type       : ui_extensions.InspectorInputType.TEXT,
        update_while_typing: true,
        datamember : this.showName
    }];

    inspectorElements.help_elements = {
        'name': 'Generator Tool'
    };

    return inspectorElements;
};

module.exports = SymbolGeneratorTerminalInteractionModel;
